// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote___B11x","modalFooterButton":"ModalNotes_modalFooterButton__18YS5"};